import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import { getProductMoneda } from '../moneda';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { getStockForItem, isCustomPrice, getStoredCartItems, serializeCartItems } from '../productStock';
import ProductMedia, { getFirstProductMedia } from '../ProductMedia/ProductMedia';
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cartVersion, setCartVersion] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [address, setAddress] = useState('');

    const guardarCarrito = (items) => {
        localStorage.setItem('cart', JSON.stringify(serializeCartItems(items)));
    };

    const getCartItemUnitPrice = (item) => isCustomPrice(item) ? 0 : Number(item?.precio || 0);
    const formatCartItemPrice = (item) => (
        isCustomPrice(item)
            ? 'Personalizable'
            : `${getProductMoneda(item)} ${item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
    );

    useEffect(() => {
        cargarContacto();
        cargarSesionCliente();
    }, []);
    useEffect(() => {
        const syncCart = () => {
            setCartVersion((current) => current + 1);
        };

        window.addEventListener('cart-updated', syncCart);
        window.addEventListener('storage', syncCart);

        return () => {
            window.removeEventListener('cart-updated', syncCart);
            window.removeEventListener('storage', syncCart);
        };
    }, []);
    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += getCartItemUnitPrice(item) * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(Array.isArray(data.contacto) ? [...data.contacto].reverse()[0] || {} : {});
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarSesionCliente = () => {
        fetch(`${baseURL}/userLogued.php?ts=${Date.now()}`, { cache: 'no-store' })
            .then(response => response.json())
            .then(data => {
                if (data?.idUsuario && data?.rol !== 'admin') {
                    setCurrentUser(data);
                    setName(data.nombre || '');
                    setEmail(data.email || '');
                    setTelefono(data.telefono || '');
                    setAddress(data.direccion || '');
                    if (data.direccion) {
                        setDeliveryOption('delivery');
                    }
                } else {
                    setCurrentUser(null);
                }
            })
            .catch(error => console.error('Error al cargar sesion del cliente en checkout:', error));
    };

    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = getStoredCartItems();
            guardarCarrito(cart);
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused, cartVersion]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => getFirstProductMedia(item);

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter((_, index) => index !== id);
        setCartItems(updatedCart);
        guardarCarrito(updatedCart);
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const validarCodigoDescuento = async (codigoIngresado = codigo) => {
        const codigoNormalizado = codigoIngresado.trim();
        if (!codigoNormalizado) {
            return { codigo: '', descuento: 0 };
        }

        try {
            const response = await fetch(`${baseURL}/codigoValidate.php?codigo=${encodeURIComponent(codigoNormalizado)}`, {
                method: 'GET',
                cache: 'no-store',
            });
            const data = await response.json();
            return {
                codigo: data.codigo || '',
                descuento: Number(data.descuento || 0),
            };
        } catch (error) {
            console.error('Error al validar código:', error);
            return { codigo: '', descuento: 0 };
        }
    };

    const handleWhatsappMessage = async () => {
        const codigoDescuento = await validarCodigoDescuento();
        const descuentoActualizado = codigoDescuento.descuento;
        setCodigoValido(Boolean(codigoDescuento.codigo));

        let totalPrice = 0;

        cartItems.forEach(item => {
            totalPrice += getCartItemUnitPrice(item) * item.cantidad;
        });

        let totalPriceWithDiscount = totalPrice - descuentoActualizado;
        if (totalPriceWithDiscount < 0) {
            totalPriceWithDiscount = 0;
        }

        const formattedTotalPrice = totalPriceWithDiscount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phoneNumber = `${contactos.telefono}`;

        const cartDetails = cartItems.map((item) => (
            `\n✅ *${item.titulo}* \n       Cantidad: ${item.cantidad}\n       Precio: ${formatCartItemPrice(item)}${item?.item ? ` \n       ${item.item}` : ''}`
        ));

        let noteMessage = '';

        if (location.trim() !== '') {
            noteMessage += `\n✅ Ubicación: ${location}`;
        }

        if (name.trim() !== '') {
            noteMessage += `\n✅ Nombre: ${name}`;
        }

        if (noteText.trim() !== '') {
            noteMessage += `\n✅ Nota: ${noteText}`;
        }

        if (codigo.trim() !== '') {
            noteMessage += `\n✅ Codigo : ${codigo}\n✅ Descuento de : ${getProductMoneda()} ${descuentoActualizado?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }

        // Añadir la dirección de entrega en el mensaje
        const entrega = deliveryOption === 'delivery' ? `Dirección de entrega: ${address}` : 'Retiro personalmente';

        const paymentMessage = paymentMethod === 'efectivo' ? 'Pago en efectivo' : 'Pago por transferencia bancaria';

        const message = `¡Hola! 🌟 Estoy interesado en encargar:\n${cartDetails.join('')}\n------------------------------------>\n ${noteMessage}\n✅ ${entrega}\n✅ ${paymentMessage}\n\n------------------------------------>\n\n*Total: ${getProductMoneda()} ${formattedTotalPrice}*`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
        setName('');
        setLocation('');
        setNoteText('');
        setCodigo('');
        setDescuento(descuentoActualizado);
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };


    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        const availableStock = getStockForItem(updatedCartItems[index], updatedCartItems[index].item);

        if (updatedCartItems[index].cantidad + 1 > availableStock) {
            toast.error(updatedCartItems[index].item ? 'No hay más stock disponible para esa talla' : 'No hay más stock disponible para este producto', { autoClose: 700 });
            return;
        }

        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        guardarCarrito(updatedCartItems);
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            guardarCarrito(updatedCartItems);
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            // Construir la lista de productos del pedido
            const productosPedido = cartItems?.map(item => {
                return {
                    titulo: item?.titulo,
                    idProducto: item?.idProducto,
                    cantidad: item?.cantidad,
                    item: item?.item,
                    precio: getCartItemUnitPrice(item),
                    moneda: getProductMoneda(item),
                    imagen: obtenerImagen(item)

                }
            });
            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);
            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += getCartItemUnitPrice(item) * item?.cantidad;
            });

            // Obtener el descuento del código de descuento
            const codigoDescuento = await validarCodigoDescuento();
            const descuentoCodigo = codigoDescuento.descuento;

            // Aplicar el descuento del código de descuento
            const totalPriceWithDiscount = totalPrice - descuentoCodigo;

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();

            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            if (currentUser?.idUsuario) {
                formData.append('idUsuario', String(currentUser.idUsuario));
            }
            formData.append('nombre', name);
            formData.append('email', email);
            formData.append('telefono', telefono);
            console.log('Valor de direccion:', address);

            const entrega = deliveryOption === 'delivery' ? address : 'Retiro en persona';
            formData.append('entrega', entrega);

            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });
            console.log(entrega)
            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                Swal.fire(
                    'Pedido enviado!',
                    data.mensaje,
                    'success'
                );
                await handleWhatsappMessage()
                clearCart()


            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );

        }
    };
    return (
        <div>
            <button onClick={openModal} className='cartIconFixed'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart' >
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <ProductMedia src={obtenerImagen(item)} alt={item.titulo} className="productMediaThumb" autoPlay muted loop />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                {item?.item ? (
                                                    <span>
                                                        <span>{item.item}</span>
                                                    </span>
                                                ) : null}
                                                <strong>{formatCartItemPrice(item)}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(index)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {getProductMoneda()} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h4>

                            <div className='deFLexBtns'>

                                <button className='btnWpp' onClick={openModal2}>
                                    Pedir por  WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                                </button>

                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                {currentUser?.idUsuario && (
                                    <div className='checkoutAccountNotice'>
                                        Tus datos se cargaron desde tu cuenta.
                                    </div>
                                )}
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre (obligatorio)'
                                />
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder='Email (obligatorio)'
                                />
                                <input
                                    type="number"
                                    id="telefono"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                    placeholder='Telefono (obligatorio)'
                                />
                                <div className='deFLexRadio'>
                                    <label>Opciones de entrega</label>

                                    <div
                                        onClick={() => setDeliveryOption('delivery')}
                                    >
                                        <input
                                            type="radio"
                                            id="delivery"
                                            name="deliveryOption"
                                            value="delivery"
                                            checked={deliveryOption === 'delivery'}
                                            onChange={() => setDeliveryOption('delivery')}
                                        />
                                        <label htmlFor="delivery">Envío a domicilio</label>
                                    </div>

                                    <div
                                        onClick={() => setDeliveryOption('pickup')}
                                    >
                                        <input
                                            type="radio"
                                            id="pickup"
                                            name="deliveryOption"
                                            value="pickup"
                                            checked={deliveryOption === 'pickup'}
                                            onChange={() => setDeliveryOption('pickup')}
                                        />
                                        <label htmlFor="pickup">Retiro en persona</label>
                                    </div>


                                </div>
                                {deliveryOption === 'delivery' && (

                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Ingresa tu dirección (obligatorio)"
                                    />

                                )}
                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    <div >
                                        <input
                                            type="radio"
                                            id="efectivo"
                                            name="paymentMethod"
                                            value="efectivo"
                                            checked={paymentMethod === 'efectivo'}
                                            onChange={() => setPaymentMethod('efectivo')}
                                        />
                                        <label htmlFor="efectivo">Efectivo</label>
                                    </div>
                                    <div >
                                        <input
                                            type="radio"
                                            id="transferencia"
                                            name="paymentMethod"
                                            value="transferencia"
                                            checked={paymentMethod === 'transferencia'}
                                            onChange={() => setPaymentMethod('transferencia')}
                                        />
                                        <label htmlFor="transferencia">Transferencia</label>
                                    </div>

                                </div>
                                <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Codigo de descuento (opcional)'
                                />
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <fieldset className='deNonefieldset'>
                                    <legend>Productos</legend>
                                    <textarea
                                        name='productos'
                                        value={cartItems.map(item => `${item.titulo}, x ${item.cantidad}, ${item.item || 'sin variantes'},${item.categoria},${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                        readOnly
                                    />
                                </fieldset>


                            </div>
                            {mensaje ? (
                                <button type='button' className='btn' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crearPedido} className='btn'>
                                    Finalizar pedido
                                </button>
                            )}
                        </Modal>

                    </>)}

            </Modal>
        </div >
    );
}
